module.exports = __webpack_public_path__ + "c788799057c79f1962c2ef6a233f0f43.svg";